import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";

interface IProps {
    reload: boolean,
    setReload: (reload: boolean) => void,
    toast: any,
}

interface IMax_Email_Setting {
    id?: number,
    company_ID?: number,
    company_Name?: string,
    limit_Days?: number,
    max_POC_Reach_P_Job?: number,
    max_Sales_P_Lead?: number,
    max_POC_Reach: number,
    updated_By?: string,
    updated_At?: Date,
}

export const CompanyMaxEmailSetting = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IMax_Email_Setting>, loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const [focusIndex, setFocusIndex] = useState<number>(-1);
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("lead-capture/leadCpaturedCompanyEmailSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMax_Email_Setting> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const onsubmit = async () => {
        setLoading(true);

        const newData: any = tableData.tableData.map((el: IMax_Email_Setting, index: number) => {

            return {
                id: el.id,
                company_ID: el.company_ID,
                limit_Days: el.limit_Days,
                max_POC_Reach_P_Job: el.max_POC_Reach_P_Job,
                max_Sales_P_Lead: el.max_Sales_P_Lead,
                max_POC_Reach: el.max_POC_Reach
            };
        });

        const method = "PUT";
        const message = "Updated Successfully";
        setLoading(true);

        const resp = await Fetch("lead-capture/updateLeadCpaturedCompanyEmailSetting", method, newData, null, null);
        if (resp) {
            props.toast.current.show({ severity: "success", detail: message, life: 3000, });
            props.setReload(!props.reload);
            setLoading(false);
            setFocusIndex(-1);
        } else setLoading(false);
    }

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const onCellEditComplete = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'limit_Days':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'max_POC_Reach_P_Job':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'max_Sales_P_Lead':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'max_POC_Reach':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };


        setTableData(prev => {
            const updatedData = prev.tableData.map((item: IMax_Email_Setting, index: any) => {
                if (index === focusIndex) {
                    setFocusIndex(-1);
                }
                if (item.id === rowData.id) {
                    return {
                        ...item,
                        limit_Days: isPositiveInteger(rowData.limit_Days) ? Number(rowData.limit_Days) : item.limit_Days,
                        max_POC_Reach_P_Job: isPositiveInteger(rowData.max_POC_Reach_P_Job) ? Number(rowData.max_POC_Reach_P_Job) : item.max_POC_Reach_P_Job,
                        max_Sales_P_Lead: isPositiveInteger(rowData.max_Sales_P_Lead) ? Number(rowData.max_Sales_P_Lead) : item.max_Sales_P_Lead,
                        max_POC_Reach: isPositiveInteger(rowData.max_POC_Reach) ? Number(rowData.max_POC_Reach) : item.max_POC_Reach,
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };
        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', cursor: "pointer" }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", }}
                size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found."
                loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="company_Name" header="Company" />
                {/* <Column field="limit_Days" header="Limit Days" body={(rowData: IMax_Email_Setting) => <p>{rowData.limit_Days}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} /> */}
                <Column field="max_POC_Reach_P_Job" header="Max POC Reach Per Job" body={(rowData: IMax_Email_Setting) => <p>{rowData.max_POC_Reach_P_Job}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="max_Sales_P_Lead" header="Max Sales Per Job" body={(rowData: IMax_Email_Setting) => <p>{rowData.max_Sales_P_Lead}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="max_POC_Reach" header="Max Reach To A POC Per Company" body={(rowData: IMax_Email_Setting) => <p>{rowData.max_POC_Reach}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
            </DataTable>
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button loading={loading} disabled={loading} style={{ width: "100px" }} label="SAVE" type="button" onClick={() => {
                    if (tableData.tableData.length > 0) {
                        onsubmit();
                    }
                }} ></Button>
            </div>
        </>
    );
}